import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_RESERVAS;

const InformeTipoMiembro = () => {
  const [alojadosPorRol, setAlojadosPorRol] = useState({});
  const [federacionSeleccionada, setFederacionSeleccionada] = useState("");
  const [alojadosPorFederacion, setAlojadosPorFederacion] = useState({});
  //const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAlojadosPorRol = async () => {
      //setLoading(true);
      try {
        const response = await axios.get(apiUrl);
        const data = response.data;

        const rolesCounts = {};
        const alojadosFederacion = {};

        data.forEach((r) => {
          r.miembros.forEach((m) => {
            if (m.rol) {
              const rolKey = m.rol.toUpperCase();
              rolesCounts[rolKey] = (rolesCounts[rolKey] || 0) + 1;
            }

            if (m.federacion_deporte && m.rol) {
              const fed = m.federacion_deporte;
              const rol = m.rol;
              if (!alojadosFederacion[fed]) alojadosFederacion[fed] = {};
              alojadosFederacion[fed][rol] = (alojadosFederacion[fed][rol] || 0) + 1;
            }
          });
        });

        setAlojadosPorRol(rolesCounts);
        setAlojadosPorFederacion(alojadosFederacion);
      } catch (error) {
        console.error("❌ Error al obtener el informe:", error);
      } finally {
        //setLoading(false);
      }
    };

    fetchAlojadosPorRol();
  }, []);

  return (
    <Box sx={{ mt: 4 }}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Filtrar por Federación</InputLabel>
            <Select
              value={federacionSeleccionada}
              label="Filtrar por Federación"
              onChange={(e) => setFederacionSeleccionada(e.target.value)}
            >
              <MenuItem value="">Todas</MenuItem>
              {Object.keys(alojadosPorFederacion).sort().map((federacion) => (
                <MenuItem key={federacion} value={federacion}>
                  {federacion}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Alojados por Rol
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
            {Object.entries(alojadosPorRol).map(([rol, cantidad]) => (
              <Card key={rol} sx={{ minWidth: 150, backgroundColor: "#f1f5f9" }}>
                <CardContent>
                  <Typography variant="subtitle2">{rol}</Typography>
                  <Typography variant="h6">{cantidad}</Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        </Grid>

        {federacionSeleccionada && (
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
              Alojados por Rol en {federacionSeleccionada}
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
              {Object.entries(alojadosPorFederacion[federacionSeleccionada] || {}).map(([rol, cantidad]) => (
                <Card key={rol} sx={{ minWidth: 150, backgroundColor: "#e2e8f0" }}>
                  <CardContent>
                    <Typography variant="subtitle2">{rol}</Typography>
                    <Typography variant="h6">{cantidad}</Typography>
                  </CardContent>
                </Card>
              ))}
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default InformeTipoMiembro;
